import React from "react";
import "./style.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-body">
        <div className="footer-text">Handcrafted by me</div>
        <div className="development">Development in progress!!</div>
      </div>
    </div>
  );
};

export default Footer;
